import { Routes, Route, useNavigate } from 'react-router-dom';
import {
  Login,
  ResetPassword,
  Support,
  ConfirmPage,
  Performance,
  Admin,
  Statement,
} from '../components';
import { useAppSelector } from '../app/hooks';
import NotFound from '../NotFound';
import NoAffiliates from '../components/NoAffiliates/NoAffiliates';
import UserHasNoAccount from '../components/UserHasNoAccount/UserHasNoAccount';

import React from 'react';

const Routing: any = () => {

const isLoggedIn = useAppSelector((store) => store.user?.isLoggedIn);
const accountNotSetup = useAppSelector((store: any) => store.user?.accountNotSetup);


  const userAffiliates = useAppSelector((store: any) => store.user?.user?.Affiliates);
  useNavigate();

  const hasAffiliates = userAffiliates && userAffiliates.length > 0;

  const getProtectedRoute = (
    Component: React.FC,
    requiresAffiliates = true
  ): React.ReactNode => {
    if (!isLoggedIn && accountNotSetup) return <UserHasNoAccount />;
    if (!isLoggedIn) return <Login />;
    if (requiresAffiliates && !hasAffiliates) return <NoAffiliates />;
    return <Component />;
  };

  return (
    <Routes>
      <Route path="/" element={getProtectedRoute(Performance)} />
      <Route path="/resetPassword" element={<ResetPassword />} />
      <Route path="/support" element={<Support />} />
      <Route path="/confirmPage" element={<ConfirmPage />} />
      <Route path="/performance" element={getProtectedRoute(Performance)} />
      <Route path="/admin" element={getProtectedRoute(Admin, false)} />
      <Route path="/statement" element={getProtectedRoute(Statement)} />
      <Route path="/UserHasNoAccount" element={<UserHasNoAccount />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
export default Routing;
